import { orderStatusFormatted } from "src/constant";

export const solveOrderType = (value) => {
  switch (value) {
    case orderStatusFormatted.ReturnRefund:
    case orderStatusFormatted.Manual:
      // case orderStatusFormatted.DeliveredFailed:
      return orderStatusFormatted.ReturnRefund;
    case orderStatusFormatted.Exchange:
      return orderStatusFormatted.Exchange;
    default:
      return orderStatusFormatted.New;
  }
};
